<template>
  <div>
    <portal target-el="#filter">
      <PrimaryFilter :key="filterUpdate" :menuOptions="Menu" @generateReport="drawer = true"
        :buttonsList="getReportButtons" :preSearchedParams="searchedParams" :searchParameters="reportSearchConstants"
        :noSearchFilter="false" :enableSearchPopup="enableSearchPopup" :searchText="'Search reports'" :showWBAgent="showWBAgent"
        @searchByParameter="searchByParameter" />
    </portal>
    <div v-if="isPageLoading"></div>
    <Row v-else :gutter="22" class="mt-m20">
      <Col :span="12" class="bg-blue-light1 pt-20" style="height: calc(100vh - 110px);
            overflow: auto;">
      <Row :gutter="16">
        <Col :span="12">
        <div v-for="report in group1Reports" class="cards" v-bind:key="report.id">
          <Radio v-model="radio" :label="report.id" @change="radioChange">
            <h4 class="d-flex">
              <div class="break-word wp-w90 radio-left-label">{{ report.name }}</div>
              <span class="f-right text-center" style="margin-top:-6px;">
                <Tooltip placement="bottom">
                  <div slot="content" class="checkbox_instruction tooltipcontent">
                    <div class="tooltipcontent_header">REPORT HEADERS</div>
                    <ul class="flexgroup">
                      <li style="display: block" v-for="(header, index) in report.reportHeaders" v-bind:key='index'>
                        {{ header }}
                      </li>
                    </ul>
                  </div>
                  <span class="text-xs">{{ report.reportHeaders.length }}
                    <small style="font-size:8px;line-height:8px;"
                      class="d-block text-grey-medium10">header</small></span>
                </Tooltip>
              </span>
            </h4>
            <p v-if="report.description">{{ report.description }}</p>
          </Radio>
        </div>
        </Col>
        <Col :span="12">
        <div v-for="report in group2Reports" class="cards" v-bind:key="report.id">
          <Radio v-model="radio" :label="report.id" @change="radioChange">
            <h4 class="d-flex">
              <div class="break-word wp-w90 radio-left-label">{{ report.name }}</div>
              <span class="f-right text-center" style="margin-top:-6px;">
                <Tooltip placement="bottom">
                  <div slot="content" class="checkbox_instruction tooltipcontent">
                    <div class="tooltipcontent_header">REPORT HEADERS</div>
                    <ul class="flexgroup">
                      <li v-for="(header, index) in report.reportHeaders" v-bind:key='index'>
                        {{ header }}
                      </li>
                    </ul>
                  </div>
                  <span class="text-xs">{{ report.reportHeaders.length }}
                    <small style="font-size:8px;line-height:8px;"
                      class="d-block text-grey-medium10">header</small></span>
                </Tooltip>
              </span>
            </h4>
            <p v-if="report.description">{{ report.description }}</p>
          </Radio>
        </div>
        </Col>
      </Row>
      </Col>

      <Col :span="12" style="border-left: 1px solid #E2EAEC;">
      <div class="justify-content d-flex align-items-center">
        <h4 class="text-brand text-capitalize text-sm mb-10">Queued Reports</h4>
        <div class="d-flex align-items-center ml-auto">
          <div class="">
            {{ "Show my reports" }}
            <SwitchBtn label="right" v-model="showMyReportsOnly" @change="toggleReportsView" :disabled="isTableLoading"
              class="default-switch ml-auto w-75">
            </SwitchBtn>
          </div>
          <div class="refresh-btn">
            <svgicon name="icon-fetch" width="10" height="10" @click="reloadReportList" />
          </div>
        </div>
      </div>
      <div style="height: calc(100vh - 160px);
            overflow: auto;">
        <div class="bg-white">
          <div v-if="isTableLoading" class="text-center py-20">
            <div class="spinner"></div>
            <p class="mt-10 text-grey-medium">Loading reports...</p>
          </div>
          <Table v-else class="table-striped bordered mt-10" :data="triggeredReports"
            :row-class-name="'is-disabled-text'" :stripe="true">
            <TableColumn prop="no" label="S.no" width="50">
            </TableColumn>
            <TableColumn prop="name" label="Report Name | Report Filter" width="190">
              <template slot-scope="scope">
                <div class="">
                  <p class="m-0">{{ scope.row.name }}
                  </p>
                  <Tooltip placement="bottom">
                    <div slot="content" class="checkbox_instruction tooltipcontent flexgroup"
                      v-for="(value, key) in scope.row.arguments" :key="key">
                      <div class="tooltipcontent_header">{{ key }}</div>
                      <ul v-if="isArray(value)" class="flexgroup mt-15">
                        <li v-for="(item, index) in value.slice(0, 5)" v-bind:key='index'>
                          {{ item }}
                        </li>
                        <li v-if="value.length > 5">
                          +{{ value.length - 5 }} more
                        </li>
                      </ul>
                      <ul v-else>
                        <li>
                          {{ value }}
                        </li>
                      </ul>
                    </div>
                    <small v-if="scope.row.arguments" style="font-size:10px;line-height:10px;"
                      class="py-5 d-block text-grey-medium10">
                      {{ Object.keys(scope.row.arguments).length }} filters</small>
                  </Tooltip>
                </div>
              </template>
            </TableColumn>
            <TableColumn prop="status" label="Status" width="90">
              <template slot-scope="scope">
                <span class="text-xs tag-badge bg bg-primary text-capitalize" :class="reportStatus[scope.row.status]">
                  <strong>{{ reportStatusType[scope.row.status] }}</strong>
                </span>
              </template>
            </TableColumn>
            <TableColumn prop="generate" label="generate time | generated by" sortable width="220">
              <template slot-scope="scope">
                <div>
                  <p class="m-0">{{ scope.row.createdAt }}</p>
                  <small>{{ scope.row.createdBy }}</small>
                </div>
              </template>
            </TableColumn>
            <TableColumn prop="icon">
              <template slot-scope="scope">
                <div class="f-right" :class="{ 'pointer': scope.row.status === 2 }"
                  v-if="downloadStatus[scope.row.status]">
                  <svgicon :name="downloadStatus[scope.row.status]" width="14" height="14" :original="true"
                    @click=" scope.row.status === 2 ? downloadReport(scope.row) : null" />
                </div>
              </template>
            </TableColumn>
          </Table>
        </div>
      </div>
      </Col>
    </Row>

    <Drawer direction="rtl" :visible.sync="drawer" :wrapperClosable="false" :with-header="false"
      class="default-drawer dark">
      <div class="default-slider slider-dark">
        <div class="drawer-header px-15">
          Generate Report
          <div class="header-item ml-auto">
            <Button type="secondary" size="mini" @click="closeGenerateReportTab">Cancel
            </Button>
            <Button type="primary" size="mini" :disabled="disableGenerateReportBtn" @click="generateReport">Generate
            </Button>
          </div>

        </div>
        <div class="px-20 drawer-container">
          <ul class="drawer-list list-flex mt-10">
            <li class="mb-5" v-if="!disableDepotFilter">
              <label> Depot</label>
              <div class="list-content">
                <Select v-if="isSingeDepotSelection" :key="'single'" v-model="selectedSingleDepot" align="right" size="mini" filterable remote
                  reserve-keyword :remote-method="searchDepots" popper-class="select-dark-dropdown text-right"
                  class="select-default select-dark" @change="filterChange" @focus="onDepotFocus"
                  @clear="clearDepotSearch" placeholder="Search depots by name or ID..." :loading="isLoadingDepots">
                  <Option v-for="item in filteredDepotsList.filter(d => d.id !== 'all')" :key="item.id" :label="item.name" :value="item.id">
                  </Option>
                </Select>
                <Select v-else :key="'multiple'" v-model="selectedDepot" collapse-tags multiple align="right" size="mini" filterable remote
                  reserve-keyword clearable :remote-method="searchDepots" popper-class="select-dark-dropdown text-right"
                  class="select-default select-dark" @change="filterChange" @focus="onDepotFocus"
                  @clear="clearDepotSearch" placeholder="Search depots by name or ID..." :loading="isLoadingDepots">
                  <Option v-for="item in filteredDepotsList" :key="item.id" :label="item.name" :value="item.id">
                  </Option>
                </Select>
              </div>
            </li>

            <li class="mb-5" v-if="!disableMovementTransporterFilter">
              <label> Movement</label>
              <div class="list-content">
                <Select v-model="selectedMovement" align="right" size="mini"
                  popper-class="select-dark-dropdown text-right" class="select-default select-dark">
                  <Option v-for="item in movementType" :key="item.id" :label="item.name" :value="item.id">
                  </Option>
                </Select>
              </div>
            </li>

            <li class="mb-5" v-if="!disableMovementTransporterFilter">
              <label> Transporter</label>
              <div class="list-content">
                <Select v-model="selectedTransporter" align="right" size="mini" filterable remote reserve-keyword
                  clearable :remote-method="searchTransporters" popper-class="select-dark-dropdown text-right"
                  class="select-default select-dark" @focus="onTransporterFocus" @clear="clearTransporterSearch"
                  placeholder="Search transporters by name or ID..." :loading="isLoadingTransporters">
                  <Option v-for="item in filteredTransporterList" :key="item.id" :label="item.name" :value="item.id">
                    <span style="float: left">{{ item.name }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.reference_id }}</span>
                  </Option>
                </Select>
              </div>
            </li>
            <li class="mb-5" v-if="showStatusFilter">
              <label> Status</label>
              <div class="list-content">
                <Select v-model="selectedStatus" multiple collapse-tags align="right" size="mini"
                  popper-class="select-dark-dropdown text-right" class="select-default select-dark">
                  <Option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value">
                  </Option>
                </Select>
              </div>
            </li>
            <li class="mb-5">
              <label> {{ selectedReport.isDispatchDateBased ? 'Dispatched Date' : 'Created Date' }} </label>
              <div class="list-content">
                <DatePicker v-model="dateFilter" type="daterange" range-separator="-" start-placeholder="Start date"
                  end-placeholder="End date" size="mini" popper-class="popper-dark"
                  class="datepicker-dark daterange no-bg" :clearable="false" :picker-options="datePickerOptions"
                  @change="filterChange" />
              </div>
            </li>
            <div style="width: 100%;text-align: right; font-size: 1rem;padding-top: 5px;">
              <span v-if="dateMaxRangeError" class="d-block text-alert">{{ getDateFilterErrorMesssage() }}</span>
              <span v-if="depotFilterError" class="d-block text-alert">{{ $getErr("DEPOT_FILTER_ERROR") }}</span>
              <span v-if="selectedReport" class="d-block text-grey-medium" style="font-size: 0.8rem;">
                Select any {{ getDefaultFilterDateRange() === -1 ? '45' : getDefaultFilterDateRange() }} days range within last 24 months
              </span>
            </div>
          </ul>
          <div class="card popper-dark p-10" v-if="duplicateReport">
            <h3 class="text-orange text-md  text-bold">Duplicate Report</h3>
            <div class="d-flex align-items-center justify-between" style="justify-content: space-between;">
              <p class="d-flex align-items-center">
                <span>
                  <img src="@common/asset/svg/excel.svg" alt="Excel Icon" />
                </span>
                <span class="text-white text-md text-bold" style="margin-left: 1rem;">
                  {{ duplicateReport.report_name }}
                </span>
              </p>
              <p>
                <a class="text-white text-md text-bold pointer" :href="duplicateReport.s3_link" target="_blank"
                   style="text-decoration: none">
                  DOWNLOAD
                </a>
              </p>
            </div>
          </div>
          <div class="card popper-dark p-10" style="margin-top: 50vh">
            <div class="text-grey_lighter10 text-sm text-bold"> {{ $t('REPORT_DISCLAIMER') }}</div>
            <div class="text-grey_lighter10 mt-5 text-bold" v-html="$t('REPORT_DISCLAIMER_MSG')" />
          </div>
        </div>

      </div>

    </Drawer>
  </div>
</template>
<script>
import PrimaryFilter from '@/components/common/PrimaryFilter';
import { Menu, reportButtons, filters, reportStatusType } from '@/constants/reportConstants';
import { movementTypeMenu } from '@/constants/order';
import { mapGetters } from 'vuex';
import moment from 'moment';
import debounce from 'debounce';

export default {
  name: 'report-v2',
  components: {
    PrimaryFilter,
  },
  data() {
    return {
      depotsList: [],
      enableSearchPopup: true,
      singleDepotFilterGroup: ['Optima Variance', 'Optima Variance Summary', 'Optima vs Dispatch Materials'],
      reportStatus: {
        2: 'bg-success',
        1: 'bg-purple-light',
        3: 'bg-danger',
        4: 'bg-orange-light',
        5: 'bg-invalid',
      },
      reportStatusType,
      downloadStatus: {
        2: 'icon-download-xl',
        1: 'icon-time',
      },
      Menu,
      reportButtons,
      reports: [],
      filters,
      transporterList: [],
      filteredTransporterList: [],
      filteredDepotsList: [],
      movementTypeMenu,
      showMyReportsOnly: false, // Default to show only my reports
      singleDayDateRange: [moment().toString(), moment().endOf('day').toString()],
      defaultDateRange: [moment().subtract(45, 'days').startOf('day').toString(), moment().endOf('day').toString()],
      disableGenerateReportBtn: true,
      disableDepotFilter: false,
      disableMovementTransporterFilter: false,
      depotFilterError: false,
      dateMaxRangeError: false,
      movementType: [],
      isTableLoading: false,
      isPageLoading: true,
      isLoadingDepots: false,
      isLoadingTransporters: false,
      duplicateReport: null,
      enabledGenerateBtn: false,
      dateFilterError: false,
      radio: null,
      selectedReportIndex: 0,
      dateFilter: [],
      selectedDepot: [],
      selectedSingleDepot: null,
      selectedMovement: null,
      selectedTransporter: null,
      selectedStatus: [],
      statusOptions: [
        { label: 'All', value: 'all' },
        { label: 'Indented', value: 0 },
        { label: 'Assigned', value: 4 },
        { label: 'Arrived', value: 5 },
        { label: 'Dispatched', value: 6 },
        { label: 'Del pending', value: 23 },
        { label: 'Delivered', value: 7 },
      ],
      selectedReport: {},
      filteredReports: [],
      queriedReports: [],
      group1Reports: [],
      group2Reports: [],
      filterUpdate: 0,
      reportSearchConstants: [
        {
          name: 'Report Name',
          query: 'name',
        },
        {
          name: 'Report Headers',
          query: 'headers',
        },
      ],
      searchedParams: {},
      drawer: false,
    };
  },
  async created() {
    if (!this.$hasFeature('report_v2')) {
      this.$router.push({ name: 'reports' });
    }
    this.$root.$on('refreshReportList', this.reloadReportList);
    try {
      const list = await this.$store.dispatch('dashboard/transporterlist');
      this.reports = await this.$store.dispatch('report/reportsConfig');
      await this.$store.dispatch('report/getReportList');
      if (list && Array.isArray(list)) {
        list.unshift({ id: -1, name: 'All Transporters', tlabel: 'INDENT_ALL_TRANSPORTER' });
        this.transporterList = list;
      }
      if (this.configurations.inboundConfig) {
        const allowedMovementTypes = this.movementTypeMenu.filter(_movementType =>
          (_movementType.check_config
            ? this.configurations.inboundConfig[_movementType.check_config]
            : true),
        );
        this.movementType = allowedMovementTypes;
      }

      this.filteredReports = this.reports.filter(report =>
        (report.feature ? this.$hasFeature(report.feature) : true) &&
        (report.permission ? this.$hasPermission(report.permission) : true));

      await this.loadFilterOptions();
      this.loadSearchFromSession();
      this.setDefaultFilters();
      this.loadData();
      this.filterUpdate += 1;
    } catch (error) {
      console.error('Error initializing component:', error);
      this.$errorMessage({
        message: 'Failed to load initial data. Please refresh the page.',
      });
    } finally {
      this.isPageLoading = false;
    }
  },
  beforeDestroy() {
    this.$root.$off('refreshReportList', this.reloadReportList);
  },
  watch: {
    drawer(newVal) {
      if (newVal && this.selectedReport) {
        // When drawer opens, set the date range for the selected report
        this.setDateRangeForReport();
      }
      if (!newVal) {
        this.duplicateReport = null;
      }
    },
  },
  computed: {
    ...mapGetters({
      depots: 'app/depots',
      configurations: 'app/configurations',
      SearchParams: 'report/getSearchParams',
      triggeredReports: 'report/getTriggeredReports',
      features: 'app/features',
    }),
    getReportButtons() {
      const buttonList = this.reportButtons;
      const buttonIndex = buttonList.findIndex(button => button.name === 'Generate Report');
      if (this.selectedReportIndex === 0) {
        buttonList[buttonIndex].disabled = true;
      } else {
        buttonList[buttonIndex].disabled = false;
      }
      return buttonList;
    },
    datePickerOptions() {
      if (!this.selectedReport) {
        return {};
      }

      const currentDate = moment();
      const minDate = currentDate.clone().subtract(24, 'months').startOf('day').toDate();
      const maxDate = currentDate.endOf('day').toDate();

      return {
        disabledDate(date) {
          return date < minDate || date > maxDate;
        },
      };
    },
    isSingeDepotSelection() {
      return this.singleDepotFilterGroup.includes(this.selectedReport.name);
    },
    showStatusFilter() {
      if (!this.selectedReport || !this.selectedReport.apiUrl) return false;
      const statusReports = ['deliveries_pending_at_transhipment_hub', 'material_shipment_direct_transshipment_report', 'direct_shipment_report'];
      return statusReports.some(r => this.selectedReport.apiUrl.includes(r));
    },
    showWBAgent() {
      return this.configurations && this.configurations.show_workbook_agent;
    },
  },
  methods: {
    searchByParameter(params) {
      const validFilter = this.validateFilter(params);
      this.searchedParams = validFilter ? params : {};
      const filterState = validFilter ? params : {};
      this.$store.commit('report/SET_SEARCH_PARAMS', filterState);
      this.saveSearchToSession();
      this.loadData();
    },
    closeGenerateReportTab() {
      this.drawer = false;
      this.dateMaxRangeError = false;
      this.disableGenerateReportBtn = false;
    },
    validateFilter(params) {
      const paramKeys = params ? Object.keys(params) : [];
      paramKeys.forEach((attr) => {
        if (!params[attr]) {
          delete params[attr];
        }
      });
      return params;
    },
    saveSearchToSession() {
      if (this.searchedParams) {
        const sessionSearch = JSON.stringify(this.searchedParams);
        localStorage.setItem(`${this.$route.name.toLowerCase()}-search-popup`, sessionSearch);
      }
    },
    // To load pre-searched data from local during refresh
    loadSearchFromSession() {
      const sessionSearchParamsJSON = localStorage.getItem(`${this.$route.name.toLowerCase()}-search-popup`) || '{}';
      const sessionSearchParams = JSON.parse(sessionSearchParamsJSON);
      this.searchedParams = Object.assign({}, this.searchedParams, sessionSearchParams);
      const validFilter = this.validateFilter(sessionSearchParams);
      const filterState = validFilter ? sessionSearchParams : null;
      this.$store.commit('report/SET_SEARCH_PARAMS', filterState);
    },
    loadData() {
      try {
        this.isLoading = true;
        const searchParams = this.SearchParams;
        const searchKeys = this.SearchParams ? Object.keys(searchParams) : [];
        if (searchKeys.length) {
          this.queriedReports = searchKeys.reduce((acc, key) => {
            acc = acc.length ? acc : this.filteredReports;
            acc = acc.filter((_report) => {
              if (key === 'headers') {
                return _report.reportHeaders && _report.reportHeaders.some(_item =>
                  _item.toLowerCase() === (searchParams[key]
                    && searchParams[key].toLowerCase()));
              }
              return _report[key] && _report[key].toLowerCase().includes(searchParams[key]
                && searchParams[key].toLowerCase());
            });
            return acc;
          }, []);
          const halfLength = Math.round(this.queriedReports.length / 2);
          this.group1Reports = this.queriedReports.slice(0, halfLength);
          this.group2Reports = this.queriedReports.slice(halfLength);
        } else {
          const halfLength = Math.round(this.filteredReports.length / 2);
          this.group1Reports = this.filteredReports.slice(0, halfLength);
          this.group2Reports = this.filteredReports.slice(halfLength);
        }
        this.isPageLoading = false;
      } catch (e) {
        console.log('error', e);
      }
    },
    radioChange() {
      this.selectedReportIndex = this.radio;
      this.selectedReport = this.filteredReports
        .find(_report => _report.id === this.selectedReportIndex);
      this.disableDepotFilter = this.selectedReport
        && (this.selectedReport.group.includes('3') || !!this.selectedReport.hideDepotFilter);
      this.disableMovementTransporterFilter = this.selectedReport
        && (this.selectedReport.type === 'Procure' || !!this.selectedReport.hideMovementTransporterFilter);
      this.selectedStatus = [];

      // Reset depot selections when switching between single and multi-select
      if (this.isSingeDepotSelection) {
        this.selectedSingleDepot = this.depotsList[1] ? this.depotsList[1].id : null;
      } else {
        this.selectedDepot = this.depotsList[1] ? [this.depotsList[1].id] : [];
      }

      // Set date range based on report configuration
      this.setDateRangeForReport();

      this.disableGenerateReportBtn = false;
    },
    setDefaultFilters() {
      this.selectedReportIndex = 0;
      this.selectedMovement = this.movementType[0].id;
      this.selectedTransporter = this.transporterList[0].id;
      this.selectedDepot = [];
      this.selectedSingleDepot = null;
      if (this.depotsList[1]) {
        this.selectedDepot.push(this.depotsList[1].id);
        this.selectedSingleDepot = this.depotsList[1].id;
      }
      this.dateFilter = this.defaultDateRange;
    },
    async filterChange() {
      const dateRange = this.dateFilter;
      this.depotFilterError = false;
      this.dateFilterError = false;
      this.dateMaxRangeError = false;
      const depotLength = this.isSingeDepotSelection
        ? (this.selectedSingleDepot ? 1 : 0)
        : this.selectedDepot.length;
      if (depotLength <= 0) {
        this.depotFilterError = true;
      }
      if ((this.depotFilterError && !this.disableDepotFilter) || this.dateFilterError) {
        this.disableGenerateReportBtn = true;
      } else {
        this.disableGenerateReportBtn = false;
      }
      const fromDate = moment(dateRange[0]);
      const toDate = moment(dateRange[1]);

      // Check if selected range exceeds report's allowed duration
      const defaultFilterDateRange = this.getDefaultFilterDateRange();
      if (defaultFilterDateRange !== -1) {
        const maxAllowedDays = defaultFilterDateRange;
        const selectedDays = toDate.diff(fromDate, 'days');

        if (selectedDays > maxAllowedDays) {
          this.dateMaxRangeError = true;
          this.disableGenerateReportBtn = true;
        }
      } else {
        const selectedDays = toDate.diff(fromDate, 'days');

        if (selectedDays > 366) {
          this.dateMaxRangeError = true;
          this.disableGenerateReportBtn = true;
        }
      }
      if (this.selectedDepot.includes('all')) {
        this.selectedDepot = ['all'];
      }
    },
    getDateFilterErrorMesssage() {
      const defaultFilterDateRange = this.getDefaultFilterDateRange();
      if (defaultFilterDateRange === -1) {
        return 'Date range cannot exceed 12 months';
      }
      return `Date range cannot exceed ${defaultFilterDateRange} days`;
    },
    getAllDepots() {
      return this.depots.map(_item => _item.id).join(',');
    },
    async generateReport() {
      const depotValue = this.isSingeDepotSelection
        ? this.selectedSingleDepot
        : (this.selectedDepot.includes('all') ? this.getAllDepots() : this.selectedDepot.join(','));

      const payload = {
        ...(!this.disableMovementTransporterFilter ? { depot_id: depotValue } : {}),
        ...(this.selectedTransporter === -1 ? {} : { transporter_id: this.selectedTransporter }),
        ...(this.selectedMovement === -1 ? {} : { movement: this.selectedMovement }),
        ...(this.showStatusFilter && this.selectedStatus.length && !this.selectedStatus.includes('all') ? { status: this.selectedStatus.join(',') } : {}),
        start: moment(this.dateFilter[0]).startOf('day').toISOString(),
        end: moment(this.dateFilter[1]).endOf('day').toISOString(),
      };
      const result = await this.$store.dispatch(`report/${this.selectedReport.emitMethod}`, { params: payload, report: this.selectedReport });

      // Normalize status and data across success and axios error objects
      const status =
        (result && result.status) ||
        (result && result.response && result.response.status) ||
        (result === 'OK') ||
        (result && Array.isArray(result.data) && result.data.length ? 200 : 0) ||
        (result && result.response && Array.isArray(result.response.data) && result.response.data.length ? 200 : 0) ||
        0;
      const data = (result && result.data) || (result && result.response && result.response.data) || {};

      if (status >= 400 || data.errors) {
        // Duplicate case from backend: { message: 'Same request already exists', depot: isSameRequestExist }
        const duplicateList = data && data.depot;
        const isDuplicate = Array.isArray(duplicateList) && duplicateList.length > 0;

        const errMessage = (data && (data.message || (data.errors && data.errors[0] && data.errors[0].message)))
          || this.$getErr(status ? status.toString() : 'APP_CATCH_ERR');

        if (isDuplicate) {
          this.duplicateReport = duplicateList[0];
          this.$errorMessage({ message: errMessage });
          this.drawer = true; // keep open for duplicate only
        } else {
          this.$errorMessage({ message: errMessage });
          this.resetToDefaults(); // close for non-duplicate errors
        }
      } else {
        this.$successMessage({
          message: (data && data.message) ? data.message : this.$getSuccess('REPORT_GENERATE'),
        });
        this.resetToDefaults();
      }
      await this.reloadReportList();
    },
    resetToDefaults() {
      this.isPageLoading = true;
      this.drawer = false;
      this.radio = null;
      this.dateFilter = this.defaultDateRange;
      this.disableGenerateReportBtn = true;
      this.selectedStatus = [];
      this.setDefaultFilters();
      this.duplicateReport = null;
      this.isPageLoading = false;
    },
    async reloadReportList() {
      try {
        this.isTableLoading = true;

        const params = {
          my_reports: this.showMyReportsOnly ? 'true' : 'false',
        };

        await this.$store.dispatch('report/getReportListEnhanced', params);
      } catch (error) {
        this.$errorMessage({
          message: 'Failed to reload reports. Please try again.',
        });
      } finally {
        this.isTableLoading = false;
      }
    },
    isArray(value) {
      return Array.isArray(value);
    },
    downloadReport(report) {
      const url = report.s3_link;
      if (url) {
        window.open(url, '_blank');
      } else {
        this.$errorMessage({ message: 'Something went wrong - Download link not available' });
      }
    },

    // Enhanced filtering methods
    async toggleReportsView() {
      try {
        this.isTableLoading = true;

        const params = {
          my_reports: this.showMyReportsOnly ? 'true' : 'false',
        };


        await this.$store.dispatch('report/getReportListEnhanced', params);
      } catch (error) {
        this.$errorMessage({
          message: 'Failed to load filtered reports. Please try again.',
        });

        // Revert toggle state on error
        this.showMyReportsOnly = !this.showMyReportsOnly;
      } finally {
        this.isTableLoading = false;
      }
    },

    searchDepots: debounce(function (query) {
      this.isLoadingDepots = true;

      try {
        if (query && query.trim() !== '') {
          const searchTerm = query.toLowerCase().trim();

          this.filteredDepotsList = this.depotsList.filter((depot) => {
            // Search in multiple fields for better results
            const nameMatch = depot.name && depot.name.toLowerCase().includes(searchTerm);
            const refIdMatch = depot.reference_id && depot.reference_id.toLowerCase().includes(searchTerm);
            const searchTextMatch = depot.searchText && depot.searchText.toLowerCase().includes(searchTerm);

            return nameMatch || refIdMatch || searchTextMatch;
          });
        } else {
          this.filteredDepotsList = [...this.depotsList];
        }
      } catch (error) {
        this.filteredDepotsList = [...this.depotsList];
      } finally {
        this.isLoadingDepots = false;
      }
    }, 300),

    searchTransporters: debounce(function (query) {
      this.isLoadingTransporters = true;

      try {
        if (query && query.trim() !== '') {
          const searchTerm = query.toLowerCase().trim();

          this.filteredTransporterList = this.transporterList.filter((transporter) => {
            // Search in multiple fields for better results
            const nameMatch = transporter.name && transporter.name.toLowerCase().includes(searchTerm);
            const refIdMatch = transporter.reference_id && transporter.reference_id.toLowerCase().includes(searchTerm);
            const searchTextMatch = transporter.searchText && transporter.searchText.toLowerCase().includes(searchTerm);

            return nameMatch || refIdMatch || searchTextMatch;
          });
        } else {
          this.filteredTransporterList = [...this.transporterList];
        }
      } catch (error) {
        this.filteredTransporterList = [...this.transporterList];
      } finally {
        this.isLoadingTransporters = false;
      }
    }, 300),

    // Handle focus events for better UX
    onDepotFocus() {
      if (this.filteredDepotsList.length === 0 && this.depotsList.length > 0) {
        this.filteredDepotsList = [...this.depotsList];
      }
    },

    onTransporterFocus() {
      if (this.filteredTransporterList.length === 0 && this.transporterList.length > 0) {
        this.filteredTransporterList = [...this.transporterList];
      }
    },

    // Clear search methods
    clearDepotSearch() {
      this.filteredDepotsList = [...this.depotsList];
      this.isLoadingDepots = false;
    },

    clearTransporterSearch() {
      this.filteredTransporterList = [...this.transporterList];
      this.isLoadingTransporters = false;
    },


    async loadFilterOptions() {
      // Enhanced fallback logic with search text
      const processedDepots = this.depots.map(depot => ({
        ...depot,
        searchText: `${depot.name || ''} ${depot.reference_id || ''}`
          .toLowerCase()
          .trim(),
      }));

      this.depotsList = [
        { name: 'Select all', id: 'all', searchText: 'select all' },
        ...processedDepots,
      ];
      this.filteredDepotsList = [...this.depotsList];

      // Ensure transporterList has search text even in fallback
      if (this.transporterList && this.transporterList.length > 0) {
        this.transporterList = this.transporterList.map(transporter => ({
          ...transporter,
          searchText:
            transporter.searchText ||
            `${transporter.name || ''} ${transporter.reference_id || ''}`
              .toLowerCase()
              .trim(),
        }));
        this.filteredTransporterList = [...this.transporterList];
      }
    },

    getDefaultFilterDateRange() {
      // Get default_date_range_to_filter from the selected report configuration
      if (this.selectedReport && this.selectedReport.default_date_range_to_filter >= 0) {
        return this.selectedReport.default_date_range_to_filter;
      }
      return -1;
    },

    setDateRangeForReport() {
      if (!this.selectedReport) {
        this.dateFilter = this.defaultDateRange;
        return;
      }
      // Get the default filter days for this specific report
      const defaultFilterDateRange = this.getDefaultFilterDateRange();
      if (defaultFilterDateRange === -1) {
        this.dateFilter = this.defaultDateRange;
        return;
      }

      console.log(`Setting date range for report "${this.selectedReport.name}" with default_date_to_filter: ${defaultFilterDateRange}`);

      // Calculate date range based on the report's default_date_range_to_filter (in days)
      const endDate = moment().endOf('day');
      const startDate = moment(endDate).subtract(defaultFilterDateRange, 'days').startOf('day');

      this.dateFilter = [startDate.toString(), endDate.toString()];
    },
  },
};
</script>

<style lang="scss">
.flexgroup {
  flex-direction: row;
}

.refresh-btn{
  cursor: pointer;
  position: relative;
  margin-left: auto;
  background-color:#fff;
  border-radius:2px;
  padding: 8px 10px;
  border: 1px solid #EFEFEF;
}
.drawer-container{
  height: 86%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

.duplicate-badge {
  background-color: #ff4949;
  color: white;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 3px;
  margin-left: 8px;
  cursor: pointer;
  font-weight: bold;
}

.duplicate-badge:hover {
  background-color: #e73c3c;
}

.spinner {
  border: 2px solid #f3f3f3;
  border-top: 2px solid #3498db;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
